import { render, staticRenderFns } from "./SectorGrants.vue?vue&type=template&id=2c1b5485&"
import script from "./SectorGrants.vue?vue&type=script&lang=js&"
export * from "./SectorGrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports